webpackJsonp([0],{

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "3x29":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4QWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_data)?_c('div',{staticClass:"column-wrap module-wrap",attrs:{"id":_vm.target,"data-spm":_vm.spm}},[_c('h3',{staticClass:"tt"},[_vm._v(_vm._s(_vm.param.tag))]),_vm._v(" "),(_vm.param.newsStreamType === 2)?[_c('div',{staticClass:"news-list"},[_vm._l((_vm.show_mp_list),function(feed){return [_c('feed-item',{attrs:{"feed":feed}})]}),_vm._v(" "),_c('footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.load_all),expression:"!load_all"}],staticClass:"more",on:{"click":_vm.loadMore}},[_c('div',[_vm._v("查看更多")]),_c('i',{staticClass:"ico icon-fold"})])],2)]:(_vm.param.newsStreamType === 0)?[_c('div',{staticClass:"news-list"},[_vm._l((_vm.show_custom_list),function(feed){return [_c('feed-item',{attrs:{"feed":feed}})]}),_vm._v(" "),_c('footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.has_more_show),expression:"has_more_show"}],staticClass:"more",on:{"click":_vm.showMore}},[_c('div',[_vm._v("查看更多")]),_c('i',{staticClass:"ico icon-fold"})])],2)]:_vm._e(),_vm._v(" "),(_vm.param.newsStreamType === 3)?[_c('div',{staticClass:"news-list"},[_vm._l((_vm.show_operate_list),function(feed){return [_c('feed-item',{attrs:{"feed":feed}})]}),_vm._v(" "),_c('footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.load_operate_all),expression:"!load_operate_all"}],staticClass:"more",on:{"click":_vm.loadOperate}},[_c('div',[_vm._v("查看更多")]),_c('i',{staticClass:"ico icon-fold"})])],2)]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "82gT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Column_vue__ = __webpack_require__("RSvO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a01caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Column_vue__ = __webpack_require__("4QWF");
function injectStyle (ssrContext) {
  __webpack_require__("A6Jk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Column_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a01caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Column_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8KLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_moment__ = __webpack_require__("RjGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_number_str__ = __webpack_require__("IaGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp__ = __webpack_require__("hU7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_const__ = __webpack_require__("+JO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_util__ = __webpack_require__("XQ5N");







/* harmony default export */ __webpack_exports__["a"] = ({
    stateStorage: null,
    resetStateStorage: function resetStateStorage() {
        this.stateStorage = null;
    },
    buildImgList: function buildImgList(item) {
        var imgs = item.images;
        var resOut = [],
            tmpImg = void 0;
        if (imgs && imgs.length > 0) {
            resOut = imgs.slice(0, 3);
            resOut.forEach(function (item) {
                item = item.replace('c_fill,w_450,h_300,g_faces', 'c_fill,w_150,h_100,g_faces');
            });
        } else {
            tmpImg = item.picUrl || item.imageUrl || '';
            resOut = tmpImg ? [tmpImg] : [];
        }
        return resOut;
    },
    generateShowInfo: function generateShowInfo(item) {
        var images = this.buildImgList(item);
        var prePic = images[0] || item.imageUrl || item.picUrl || '';
        var picUrl = prePic.replace('c_fill,w_450,h_300', 'c_fill,w_150,h_100');
        //1.纯文本，2单图，3，三图
        var showType = 2;
        if (images.length === 3) {
            showType = 3;
        } else if (images.length === 0) {
            showType = 1;
        }
        if (item.tip_flag) {
            showType = 0;
        }
        return {
            picUrl: picUrl,
            images: images,
            showType: showType
        };
    },
    formatFeedList: function formatFeedList(_list) {
        var _findexFlag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var _streamType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        var that = this;
        var list = _list || [];
        var formatItemInfo = {};
        var tmpImgs = [];
        var news_id = void 0,
            read_num = void 0,
            c_flag = void 0,
            pubTime = void 0,
            stat_flag = void 0;
        var buildLink = function buildLink(o, i, flag) {
            var link = void 0;
            switch (_streamType) {
                // 录入文章
                case 0:
                    if (o.type === 3) {
                        link = o.articleId && o.authId ? '/a/' + o.articleId + '_' + o.authId : o.link || '';
                    } else if (o.type === 4) {
                        link = o.articleId ? '/picture/' + o.articleId : o.link || '';
                    } else {
                        link = o.link || '';
                    }
                    break;
                // mp抓取（mp接口）
                case 2:
                    link = o.id && o.authorId ? '/a/' + o.id + '_' + o.authorId : o.url || '';
                    break;
                // 场景化（整合流接口）
                case 3:
                    if (o.type === 1 || o.type == 2) {
                        // 文章
                        link = o.id && o.authorId ? '/a/' + o.id + '_' + o.authorId : o.url || '';
                    } else if (o.type === 3) {
                        // 图集
                        link = o.id ? '/picture/' + o.id : o.url || '';
                    } else {
                        link = o.url || '';
                    }
                    break;
                default:
                    break;

            }
            link = __WEBPACK_IMPORTED_MODULE_6__utils_util__["a" /* default */].addQueryArgs(link, {
                _f: flag
            });
            return link;
        };
        list.forEach(function (o, index) {
            stat_flag = _findexFlag + '_' + (index + 1);
            pubTime = o.createTime || o.publicTime;
            news_id = o.id;
            read_num = that.stateStorage ? that.stateStorage[news_id] || 0 : 0;
            o.read_num = o.read_num || new __WEBPACK_IMPORTED_MODULE_3__utils_number_str__["a" /* default */](read_num).format();
            o.title = o.title.replace(/</ig, "&lt;").replace(/>/ig, "&gt;");
            o.fix_c_time = new __WEBPACK_IMPORTED_MODULE_2__utils_moment__["a" /* default */](Number(pubTime) || new Date().getTime()).fixTime();
            formatItemInfo = that.generateShowInfo(o);
            o.picUrl = formatItemInfo.picUrl;
            o.images = formatItemInfo.images;
            o.showType = formatItemInfo.showType;
            o.pull_time = that.page_no;
            o.stat_flag = stat_flag;
            o.link = buildLink(o, index, stat_flag);
            o.author = o.authorName || o.authName || '搜狐自媒体';
        });
        return list;
    },
    initReadState: function initReadState(news_ids, callback) {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()('//v2.sohu.com/public-api/articles/pv?articleIds=' + news_ids.join(','), null, function (err, response) {
            var read_dom = void 0;
            if (err) {
                console.error(err.message);
            } else {
                if (that.stateStorage && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(that.stateStorage) === 'object') {
                    that.stateStorage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(that.stateStorage, response);
                } else {
                    that.stateStorage = response;
                }
                if (typeof callback === 'function') callback();
            }
        });
    },
    pickListByKey: function pickListByKey() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var key_list = [];
        list.forEach(function (o) {
            if (o[key]) {
                key_list.push(o[key]);
            }
        });
        return key_list;
    }
});

/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "A6Jk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZZVW");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1b8ef53a", content, true, {});

/***/ }),

/***/ "Br0I":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "EarI":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "J03W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"item",staticClass:"feed-item",attrs:{"data-mpid":_vm.feed.id,"data-pulltime":_vm.feed.pull_time}},[(_vm.feed.showType === 1)?_c('a',{ref:"link",staticClass:"plainText",attrs:{"href":_vm.feed.link,"data-log-content-ev":_vm.feed.stat_flag},on:{"click":function($event){$event.preventDefault();_vm.clickItemHandler(_vm.feed)}}},[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.feed.title)}}),_vm._v(" "),_c('footer',{staticClass:"item_info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.feed.author))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.feed.fix_c_time),expression:"feed.fix_c_time"}],staticClass:"time"},[_vm._v(_vm._s(_vm.feed.fix_c_time))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(Number(_vm.feed.read_num) !== 0),expression:"Number(feed.read_num) !== 0"}],staticClass:"cmt"},[_c('em',{staticClass:"cmt_name"},[_vm._v(_vm._s(_vm.feed.read_num))]),_vm._v("阅")])])]):_vm._e(),_vm._v(" "),(_vm.feed.showType === 2)?_c('a',{staticClass:"onePic",attrs:{"href":_vm.feed.link,"data-log-content-ev":_vm.feed.stat_flag},on:{"click":function($event){$event.preventDefault();_vm.clickItemHandler(_vm.feed)}}},[_c('div',{staticClass:"onePic_detail"},[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.feed.title)}}),_vm._v(" "),_c('div',{staticClass:"item_info"},[(_vm.feed.type === 64 || _vm.feed.type === 65 || _vm.feed.type == 182 || _vm.feed.type == 185)?_c('div',{staticClass:"qianfan icon-live"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.feed.author))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.feed.fix_c_time),expression:"feed.fix_c_time"}],staticClass:"time"},[_vm._v(_vm._s(_vm.feed.fix_c_time))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(Number(_vm.feed.read_num) !== 0),expression:"Number(feed.read_num) !== 0"}],staticClass:"cmt"},[_c('em',{staticClass:"cmt_name"},[_vm._v(_vm._s(_vm.feed.read_num))]),_vm._v("阅")])])]),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.mini_picUrl(_vm.feed.picUrl)),expression:"mini_picUrl(feed.picUrl)",arg:"background-image"}],staticClass:"onePic_img"},[(_vm.feed.type === 64 || _vm.feed.type === 65 || _vm.feed.type == 182 || _vm.feed.type == 185 || _vm.feed.type ==4 || _vm.feed.type == 5)?_c('div',{staticClass:"video-icon"}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.feed.showType === 3)?_c('a',{staticClass:"threePic",attrs:{"href":_vm.feed.link,"data-log-content-ev":_vm.feed.stat_flag},on:{"click":function($event){$event.preventDefault();_vm.clickItemHandler(_vm.feed)}}},[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.feed.title)}}),_vm._v(" "),_c('ul',{staticClass:"list_img clearfix"},[_vm._l((_vm.feed.images),function(item){return [_c('li',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.mini_picUrl(item)),expression:"mini_picUrl(item)",arg:"background-image"}],key:item,staticClass:"img_wrap"})]})],2),_vm._v(" "),_c('footer',{staticClass:"item_info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.feed.author))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.feed.fix_c_time),expression:"feed.fix_c_time"}],staticClass:"time"},[_vm._v(_vm._s(_vm.feed.fix_c_time))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(Number(_vm.feed.read_num) !== 0),expression:"Number(feed.read_num) !== 0"}],staticClass:"cmt"},[_c('em',{staticClass:"cmt_name"},[_vm._v(_vm._s(_vm.feed.read_num))]),_vm._v("阅")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "NLBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    // getCookie    
    getCookie: function getCookie(name) {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    },
    // getPvId    
    generateRand: function generateRand() {
        var rands = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var arr = new Array(7);
        var pvId;
        if (!window.randId) {
            for (var i = 0; i < arr.length; i++) {
                arr[i] = rands[parseInt(Math.random() * rands.length)];
            }
            window.randId = arr.join('');
        }
        return pvId = new Date().getTime() + window.randId;
    }
});

/***/ }),

/***/ "O+o8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("grOm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("077053aa", content, true, {});

/***/ }),

/***/ "R4wc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("kM2E");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("To3L") });


/***/ }),

/***/ "RSvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__feed_item_vue__ = __webpack_require__("mw+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_feed__ = __webpack_require__("8KLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_getCookie__ = __webpack_require__("NLBF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        target: {
            default: '',
            type: String
        },
        spm: {
            default: '',
            type: String
        },
        param: {
            default: {},
            type: Object
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data: function data() {
        var _ref;

        return _ref = {
            page_no: 1,
            page_size: 5,
            pre_mp_fetch: [],
            pre_operate_fetch: [],
            pre_custom: []
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'pre_operate_fetch', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'firstLoadNumber', 5), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'load_all', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'load_operate_all', false), _ref;
    },
    created: function created() {
        var newsStreamType = this.param.newsStreamType;

        if (this.param.firstLoadNumber > 0) {
            this.firstLoadNumber = this.param.firstLoadNumber;
        }
        switch (newsStreamType) {
            case 2:
                this.initMpFetchData();
                break;
            case 3:
                this.initOperateData();
                break;
            default:
                this.initCustomData();

        }
    },
    mounted: function mounted() {
        this.initStatistics();
    },
    updated: function updated() {
        this.initStatistics();
        this.$nextTick(function () {
            //触发统计sdk的埋点
            if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                window.sohuSpm.domDidChange();
            };
        });
    },

    methods: {
        initStatistics: function initStatistics() {
            var _this = this;

            // need Optimization
            this.$nextTick(function () {
                var feedList = void 0,
                    container = document.getElementById(_this.target);
                if (container) {
                    feedList = container.querySelectorAll('a[data-log-content-ev]');
                    _this.$emit('mounted', feedList);
                }
            });
        },
        initCustomData: function initCustomData() {
            this.pre_custom = this.param.data;
        },
        showMore: function showMore() {
            this.page_no++;
        },
        loadMore: function loadMore() {
            var _this2 = this;

            this.page_no++;
            this.fetchData({
                load_num: this.firstLoadNumber
            }, function (data) {
                _this2.pre_mp_fetch = _this2.pre_mp_fetch.concat(data);
            });
        },
        loadOperate: function loadOperate() {
            var _this3 = this;

            this.page_no++;
            this.fetchOperateData({
                load_num: this.firstLoadNumber
            }, function (data) {
                for (var i = 0; i < data.data.length; i++) {
                    if (data.data[i].images[0]) {
                        _this3.pre_operate_fetch = _this3.pre_operate_fetch.concat(data.data[i]);
                    }
                }
            });
        },
        initMpFetchData: function initMpFetchData(sucFun) {
            var _this4 = this;

            this.fetchData({
                load_num: this.firstLoadNumber
            }, function (data) {
                _this4.pre_mp_fetch = data;
            });
        },
        initOperateData: function initOperateData() {
            var _this5 = this;

            this.fetchOperateData({
                load_num: this.firstLoadNumber
            }, function (data) {
                for (var i = 0; i < data.data.length; i++) {
                    if (data.data[i].images[0]) {
                        _this5.pre_operate_fetch.push(data.data[i]);
                    }
                }
            });
        },
        fetchData: function fetchData(opt, sucFun) {
            var reqNum = void 0;
            var that = this;
            var newsStreamParam = this.param.newsStream[0];
            var reqUrl = '//v2.sohu.com/public-api/authors/' + newsStreamParam.passportId + '/articles';

            if (opt && opt.load_num > 0) {
                reqNum = opt.load_num;
            } else {
                reqNum = this.page_size;
            }
            var reqParam = {
                page: that.page_no,
                size: reqNum,
                startTimeInMilliSecond: newsStreamParam.startTime
            };
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(reqUrl, {
                params: reqParam
            }).then(function (response) {
                if (response.status === 200) {
                    if (response.data.length < reqNum) {
                        that.load_all = true;
                    }
                    if (typeof sucFun === 'function') sucFun(response.data);
                }
            }).catch(function (err) {
                console.warn(err);
            });
        },
        fetchOperateData: function fetchOperateData(opt, sucFun) {
            var that = this;
            var regionId = this.param.newsStream[0] && this.param.newsStream[0].regionId;
            if (regionId) {
                var baseUrl = '//v2.sohu.com/integration-api/mix/region/' + regionId;
                var reqNum = void 0;
                var SUV = __WEBPACK_IMPORTED_MODULE_4__helper_getCookie__["a" /* default */].getCookie('SUV');
                var pvId = __WEBPACK_IMPORTED_MODULE_4__helper_getCookie__["a" /* default */].generateRand();
                if (window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
                    pvId = window.sohuSpm.getCodes().e;
                }
                if (opt && opt.load_num > 0) {
                    reqNum = opt.load_num;
                } else {
                    reqNum = this.page_size;
                }
                var reqParam1 = {
                    size: reqNum,
                    adapter: 'adapter1',
                    page: that.page_no,
                    pvId: pvId,
                    requestId: SUV + '_' + new Date().getTime()
                };
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl, {
                    params: reqParam1
                }).then(function (response) {
                    if (response.status === 200) {
                        if (response.data.data.length < reqNum) {
                            that.load_operate_all = true;
                        }
                        if (typeof sucFun === 'function') sucFun(response.data);
                    }
                }).catch(function (err) {
                    console.warn(err);
                });
            }
        }
    },
    computed: {
        mp_list: function mp_list() {
            return __WEBPACK_IMPORTED_MODULE_3__helper_feed__["a" /* default */].formatFeedList(this.pre_mp_fetch, this.stat_flag, this.param.newsStreamType);
        },
        show_mp_list: function show_mp_list() {
            return this.mp_list.slice(0, this.show_num);
        },
        custom_list: function custom_list() {
            return __WEBPACK_IMPORTED_MODULE_3__helper_feed__["a" /* default */].formatFeedList(this.pre_custom, this.stat_flag, this.param.newsStreamType);
        },
        show_custom_list: function show_custom_list() {
            return this.custom_list.slice(0, this.show_num);
        },
        operate_list: function operate_list() {
            return __WEBPACK_IMPORTED_MODULE_3__helper_feed__["a" /* default */].formatFeedList(this.pre_operate_fetch, this.stat_flag, this.param.newsStreamType);
        },
        show_operate_list: function show_operate_list() {
            return this.operate_list.slice(0, this.show_num);
        },
        has_more_show: function has_more_show() {
            return this.custom_list.length > this.show_num;
        },
        has_more_show_operate: function has_more_show_operate() {
            return this.operate_list.length > this.show_num;
        },
        show_num: function show_num() {
            return (this.page_no - 1) * this.page_size + this.firstLoadNumber;
        },
        has_data: function has_data() {
            return !!(this.mp_list.length > 0 || this.custom_list.length > 0 || this.operate_list.length > 0);
        },
        stat_flag: function stat_flag() {
            var subId = window.subData.id;
            return 'm-' + subId + '_subfeeds_' + this.findex;
        }
    },
    components: {
        FeedItem: __WEBPACK_IMPORTED_MODULE_2__feed_item_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "Re3r":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "RjGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Moment = function Moment(time) {
    this.time = new Date(time);
};
Moment.prototype = {
    formatTime: function formatTime() {
        var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "yyyy-MM-dd hh:mm:ss";

        /*
         * eg:format="yyyy-MM-dd hh:mm:ss";
         */
        var o = {
            "M+": this.time.getMonth() + 1,
            "d+": this.time.getDate(),
            "h+": this.time.getHours(),
            "m+": this.time.getMinutes(),
            "s+": this.time.getSeconds(),
            "q+": Math.floor((this.time.getMonth() + 3) / 3),
            "S": this.time.getMilliseconds()
        };
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (this.time.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    },
    fixTime: function fixTime() {
        var that = this;
        var showStr = '';
        var now = new Date().getTime();
        var delta = Number(now) - Number(that.time);
        var perMin = 60 * 1000;
        var perHour = 60 * perMin;
        var perDay = 24 * perHour;
        if (delta > 0) {
            if (delta < perMin) {
                showStr = '刚刚';
            } else if (perMin <= delta && delta < perHour) {
                showStr = Math.floor(delta / perMin) + '分钟前';
            } else if (perHour <= delta && delta < perDay) {
                showStr = Math.floor(delta / perHour) + '小时前';
            } else {
                showStr = that.formatTime('MM-dd hh:mm');
            }
            return showStr;
        } else {
            // console.warn('传入起始时间早于当前时间');
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Moment);

/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "To3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
var toObject = __webpack_require__("sB3e");
var IObject = __webpack_require__("MU5D");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("S82l")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "UTZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");


var nativeUtil = {
    openContent: function openContent(url, data) {
        if (!url) {
            return;
        }
        if (/MSOHU/i.test(window.navigator.userAgent) && window.Panther) {
            var urlObj = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].parseURL(url);
            var spmCode = urlObj.spm || '';
            var scmCode = urlObj.scm || '';
            var regMatch = /\/(a|picture)\/(\d+)(_\d+\?|\?)/.test(url);
            var authorId = data.authorId || data.authId;
            if (RegExp.$1 === 'a') {
                // 匹配文章页
                if (typeof Panther.openNewsContent === 'function') {
                    Panther.openNewsContent(RegExp.$2, spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else if (RegExp.$1 === 'picture') {
                // 匹配图集页
                if (typeof Panther.openImageSet === 'function') {
                    Panther.openImageSet(Number(RegExp.$2), spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else {
                window.location.href = url;
            }
        } else {
            window.location.href = url;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (nativeUtil);

/***/ }),

/***/ "V3tA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("R4wc");
module.exports = __webpack_require__("FeBl").Object.assign;


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "ZZVW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.column-wrap {\n  margin: 0 0.346667rem 0.266667rem 0.346667rem;\n  padding: 0.373333rem 0 0.266667rem 0;\n  border-bottom: 1px solid #f5f5f5;\n}\n.column-wrap .tt {\n  font-size: 17px;\n  color: #222222;\n  font-weight: bold;\n}\n.column-wrap .news-list .feed-item:last-of-type {\n  border: none;\n}\n.column-wrap .news-list .more {\n  padding-top: 0.213333rem;\n  padding-bottom: 0.266667rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 14px;\n  color: #999;\n}\n.column-wrap .news-list .more .ico {\n  font-size: 14px;\n}\n.column-wrap .news-list .no-data {\n  line-height: 1.973333rem;\n  color: #999;\n}", ""]);

// exports


/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("Re3r");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "gIbM":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("EarI");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "grOm":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.feed-item {\n  position: relative;\n  padding-top: 0.32rem;\n  padding-bottom: 0.32rem;\n  border-bottom: 1px solid #f5f5f5;\n}\n.feed-item .plainText .title {\n  margin-bottom: 0.2rem;\n  /*使用margin为了防止overflow 裁掉一半文字*/\n  font-size: 18px;\n  line-height: 1.3em;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  display: box;\n  -webkit-box-orient: vertical;\n  color: #212121;\n}\n.feed-item .plainText .item_info {\n  padding-top: 0.053333rem;\n  color: #999;\n  font-size: 0.32rem;\n  overflow: hidden;\n}\n.feed-item .plainText .item_info .name {\n  float: left;\n  max-width: 10em;\n  line-height: 1.05em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.feed-item .plainText .item_info .time {\n  float: left;\n  position: relative;\n  line-height: 1.05em;\n  padding-left: 0.4rem;\n}\n.feed-item .plainText .item_info .time:before {\n  content: '\\B7';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0.4rem;\n  text-align: center;\n}\n.feed-item .plainText .item_info .cmt {\n  float: right;\n  color: #212121;\n}\n.feed-item .plainText .item_info .cmt .cmt_name {\n  float: left;\n  margin-right: 0.106667rem;\n}\n.feed-item .onePic {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.feed-item .onePic .onePic_detail {\n  position: relative;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.feed-item .onePic .onePic_detail .title {\n  margin-right: 0.266667rem;\n  font-size: 18px;\n  line-height: 1.3em;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  display: box;\n  -webkit-box-orient: vertical;\n  color: #212121;\n}\n.feed-item .onePic .onePic_detail .item_info {\n  overflow: hidden;\n  color: #999;\n  font-size: 0.32rem;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-right: 0.586667rem;\n}\n.feed-item .onePic .onePic_detail .item_info .qianfan {\n  float: left;\n  font-size: 0.32rem;\n  line-height: 1.05em;\n  margin-right: 0.106667rem;\n}\n.feed-item .onePic .onePic_detail .item_info .name {\n  float: left;\n  max-width: 6em;\n  line-height: 1.2em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.feed-item .onePic .onePic_detail .item_info .time {\n  float: left;\n  position: relative;\n  line-height: 1.05em;\n  padding-left: 0.4rem;\n}\n.feed-item .onePic .onePic_detail .item_info .time:before {\n  content: '\\B7';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0.4rem;\n  text-align: center;\n}\n.feed-item .onePic .onePic_detail .item_info .cmt {\n  float: right;\n  color: #212121;\n}\n.feed-item .onePic .onePic_detail .item_info .cmt .cmt_name {\n  float: left;\n  margin-right: 0.106667rem;\n}\n.feed-item .onePic .onePic_img {\n  position: relative;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: 32.75346%;\n  padding-top: 21.55%;\n  background-size: cover;\n  background-image: url(" + escape(__webpack_require__("Br0I")) + ");\n}\n.feed-item .onePic .onePic_img .video-icon {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 0.853333rem;\n  height: 0.853333rem;\n  margin: auto;\n  background: url(" + escape(__webpack_require__("3x29")) + ") no-repeat center center;\n  background-size: contain;\n}\n.feed-item .threePic .title {\n  margin-bottom: 0.2rem;\n  /*使用 margin 为了防止overflow 裁掉一半文字*/\n  font-size: 18px;\n  line-height: 1.3em;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  display: box;\n  -webkit-box-orient: vertical;\n  color: #212121;\n}\n.feed-item .threePic .list_img .img_wrap {\n  float: left;\n  width: 32.75346%;\n  padding-top: 21.55%;\n  overflow: hidden;\n  background-size: cover;\n  background-image: url(" + escape(__webpack_require__("Br0I")) + ");\n}\n.feed-item .threePic .list_img .img_wrap:first-child {\n  margin-right: 0.8698%;\n}\n.feed-item .threePic .list_img .img_wrap:last-child {\n  margin-left: 0.8698%;\n}\n.feed-item .threePic .item_info {\n  padding-top: 0.266667rem;\n  color: #999;\n  font-size: 0.32rem;\n  overflow: hidden;\n}\n.feed-item .threePic .item_info .name {\n  float: left;\n  max-width: 10em;\n  line-height: 1.05em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.feed-item .threePic .item_info .time {\n  float: left;\n  line-height: 1.05em;\n  position: relative;\n  padding-left: 0.4rem;\n}\n.feed-item .threePic .item_info .time:before {\n  content: '\\B7';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0.4rem;\n  text-align: center;\n}\n.feed-item .threePic .item_info .cmt {\n  float: right;\n  color: #212121;\n}\n.feed-item .threePic .item_info .cmt .cmt_name {\n  float: left;\n  margin-right: 0.106667rem;\n}\n@-webkit-keyframes fadeOut {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes fadeOut {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}", ""]);

// exports


/***/ }),

/***/ "hU7x":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__("rRaD")('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ "ipAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus__ = __webpack_require__("tmAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_native_util_js__ = __webpack_require__("UTZg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util_js__ = __webpack_require__("XQ5N");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        feed: {},
        pulltime: {
            default: 1
        }
    },
    methods: {
        clickItemHandler: function clickItemHandler(data) {
            var url = this.$refs.item.querySelector('a').getAttribute('href');
            __WEBPACK_IMPORTED_MODULE_1__utils_native_util_js__["a" /* default */].openContent(url, data);
        },

        mini_picUrl: __WEBPACK_IMPORTED_MODULE_2__utils_util_js__["a" /* default */].mini_picUrl
    },
    components: {}
});

/***/ }),

/***/ "kxFB":
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mw+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feed_item_vue__ = __webpack_require__("ipAD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217fbafa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feed_item_vue__ = __webpack_require__("J03W");
function injectStyle (ssrContext) {
  __webpack_require__("O+o8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feed_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217fbafa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feed_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "rRaD":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("gIbM");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "tmAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* unused harmony default export */ var _unused_webpack_default_export = (eventBus);

/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V3tA"), __esModule: true };

/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.0de42fdf0f113c49db28.js